import React from 'react';
import { Group, Line } from 'react-konva';

interface RotationHotspotsProps {
  cx: number;
  cy: number;
  width: number;
  height: number;
  rotation: number;
  onStart: (startAngleDeg: number) => void;
}

export const RotationHotspots: React.FC<RotationHotspotsProps> = ({ cx, cy, width, height, rotation, onStart }) => {
  const zone = 12;
  const pad = 20;
  const Ring: React.FC<{ start: [number, number]; end: [number, number] }> = ({ start, end }) => (
    <Line
      points={[start[0], start[1], end[0], end[1]]}
      stroke="#00000000"
      hitStrokeWidth={zone}
      listening
      onMouseEnter={() => { document.body.style.cursor = 'alias'; }}
      onMouseLeave={() => { document.body.style.cursor = 'default'; }}
      onMouseDown={(e) => {
        const stage = e.target.getStage();
        if (!stage) return;
        const pos = stage.getPointerPosition();
        if (!pos) return;
        const scale = stage.scaleX();
        const canvasPos = { x: (pos.x - stage.x()) / scale, y: (pos.y - stage.y()) / scale };
        const startAngle = Math.atan2(canvasPos.y - cy, canvasPos.x - cx) * 180 / Math.PI;
        onStart(startAngle);
      }}
    />
  );
  const Corner: React.FC<{ corner: [number, number] }> = ({ corner }) => {
    const vx = corner[0];
    const vy = corner[1];
    const mag = Math.sqrt(vx * vx + vy * vy) || 1;
    const nx = vx / mag;
    const ny = vy / mag;
    const start: [number, number] = [corner[0], corner[1]];
    const end: [number, number] = [corner[0] + nx * pad, corner[1] + ny * pad];
    return <Ring start={start} end={end} />;
  };
  return (
    <Group x={cx} y={cy} rotation={rotation} listening>
      <Corner corner={[-width / 2, -height / 2]} />
      <Corner corner={[width / 2, -height / 2]} />
      <Corner corner={[width / 2, height / 2]} />
      <Corner corner={[-width / 2, height / 2]} />
    </Group>
  );
};


